import { TenantsApi, UpdateTenantDto } from '../../../api-client';
import { useMutation, UseMutationResult } from 'react-query';
import { AxiosResponse } from 'axios';
import { ErrorResponse } from '../../../common/types/errorRespose';

export const useUpdateTenant = (
  tenantsApi: TenantsApi,
  onError: (err: ErrorResponse) => void,
  onSuccess: (data: AxiosResponse<void>) => void,
): UseMutationResult<
  AxiosResponse<void>,
  ErrorResponse,
  {
    id: string;
    updateTenantDto: UpdateTenantDto;
  }
> =>
  useMutation(
    ({ id, updateTenantDto }: { id: string; updateTenantDto: UpdateTenantDto }) =>
      tenantsApi.updateTenant(id, updateTenantDto),
    {
      onError,
      onSuccess,
    },
  );
